// Custom VFG components
// HTML data area

<template>
        <html-renderer-old
        class="html-template-render"
            :template="theTemplate" 
            :model="dataModelScope"
            :schema="schema.modelSchema || schema"
            :value="value"  
            :app="schema.modelApp || $store.state.site.content.app"  
            :params="$store.state.site.content.params" 
            >
        </html-renderer-old>
</template>
 
<script>

    import { EventBus } from 'Js/eventBus';

    const target = {
        message1: function(a){console.log('@message1 text: ', a)},
        message2: "everyone"
    };

    export default {
        props: [],
        name: 'htmlblock',
        mixins: [VueFormGenerator.abstractField],
        methods: {
        },
        
        computed: {
            
            dataModelScope: function() {
                // if a scope is defined use that as the root for the data model
                return (this.schema.dataModelScope ? _.get(this.model, this.schema.dataModelScope  ) : this.model)
            },
            
            theTemplate: function() {
                let theTemplate = this.value ? this.value : ""
                theTemplate += this.schema.html ? this.schema.html : ""
                let divWrapper = 'divWrapper' in this.schema ? this.schema.divWrapper : true
                return divWrapper? `<div class="html-wrapper" style="width: 100%;">${theTemplate}</div>` : theTemplate
            }
        },
        
        errorCaptured(err, vm, info) {
          BF.errorThrow(10021, 'BF HTML element error, (See info for details)', { name: err.name, message: err.message });
          return false;
        },

        created() {},
        data() {
                return {
                }
            }
        
    }
</script>

<style>

    .wrapper {
        width: 100%
    }
    
</style>

                             
